var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-sf"},[_c('img',{staticClass:"banner",attrs:{"src":require("@/assets/images/about-sf/banner.jpg"),"alt":"关于顺丰banner图片"}}),_vm._v(" "),_c('nav-component',{attrs:{"navs":_vm.navs,"active-index":_vm.navIndex},on:{"on-switch":_vm.switchNav}}),_vm._v(" "),_c('router-view',{key:_vm.key}),_vm._v(" "),_c('to-top')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04567207","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about-sf/index.vue
// module id = null
// module chunks = 